import { Button, SimpleText, SimpleCallback } from 'platform-components';
import React from 'react';

import './lesson-editor-widget__controls.scss';

interface OwnProps {
    onEdit: SimpleCallback;
    textId: string;
}

interface Props extends OwnProps {}

const LessonEditorWidgetControls = ({ onEdit, textId }: Props) => (
    <Button className="lesson-editor-widget__control" onClick={onEdit}>
        <SimpleText id={textId} />
    </Button>
);

export default LessonEditorWidgetControls;
